<template>
    <van-overlay
        class="OverlayMsgCom"
        :show="show"
        @click="onLayerClick"
        z-index="9999999"
    >
        <div class="wrapper">
            <!-- <van-image
                style="width: 30%; position: absolute; top: 150px; left: 50%; transform: translateX(-50%); z-index: 2;"
                src="https://oss.megabit.co.nz/jifu/uploads/202504120231734.png"
            >
            </van-image> -->
            <div class="block">
                <van-image
                    draggable="false"
                    style="width: 100%; display: block"
                    src="https://oss.megabit.co.nz/jifu/uploads/202504120305767.png"
                >
                </van-image>
                <p class="content-title">
                    Outside Service Hours
                </p>
                <span class="content-desc">
                    Our services are currently unavailable as we are outside of our operating hours.
                    Please visit us again during our service hours.
                    Thank you for your understanding!
                </span>
            </div>
        </div>
    </van-overlay>
</template>
<script setup>
import { defineProps, ref, watch, onMounted, nextTick } from "vue"

// MARK - Props
// ************************************************************************
const props = defineProps({
    show: Boolean,
    title: String,
    desc: String,
})

// MARK - LIFE CYCLE
// ************************************************************************
watch(
    () => props.show,
    (newVal) => {
        nextTick(() => {
            if (newVal) {
                document.body.style.overflow = "hidden"
            } else {
                document.body.style.overflow = ""
            }
        })
    }
)

onMounted(() => {
    if (props.show) {
        document.body.style.overflow = "hidden"
    }
})

// MARK - Methods
// ************************************************************************
const onLayerClick = () => {}
</script>
<style>
.OverlayMsgCom {
    width: 100vw;
    height: 100wh;
}

.OverlayMsgCom .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
    width: 100%;
}

.OverlayMsgCom .block {
    width: 320px;
    max-width: 90%;
    height: 420px;
    max-height: 80%;
    background-color: #fff;
    border-radius: 36px;
    overflow: hidden;
}

.OverlayMsgCom .content-title {
    color: red;
    font-size: 24px;
    font-weight: 800;
    padding-bottom: 4px;
    margin-bottom: 4px;
}

.OverlayMsgCom .content-desc {
    padding: 0 12px;
    text-align: left;

}

</style>
